import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

import _ from "lodash";

declare let $: any;

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  constructor(public http: HttpClient) {}

  list(inParams: any = {}): any {
    const params = {...inParams};

    if (params.$page) {
      params.$skip = (params.$page - 1) * (params.$limit);
    }
    delete params.$page;

    if (!params.status) {
      delete params.status;
    }

    const query = $.param(params);
    const url = `${environment.taskSharingApiUrl}/projects?${query}`;
    return this.http.get(url);
  }

  save(model): any {
    if (model.id) {
      const updateUrl = `${environment.taskSharingApiUrl}/projects/${model.id}`;
      return this.http.patch(updateUrl, model);
    }

    delete model.id;
    const url = `${environment.taskSharingApiUrl}/projects`;
    return this.http.post(url, model);
  }

  detail(id): any {
    const url = `${environment.taskSharingApiUrl}/projects/${id}`;
    const params: any = {
      $populate: ["user", "author"],
    };

    return this.http.get(url, { params });
  }

  delete(model): any {
    const url = `${environment.taskSharingApiUrl}/projects/${model.id}`;
    return this.http.delete(url);
  }

  percentage(item) {
    if (!item) {
      return 0;
    }
    
    if (item.status === 'completed') {
      return 100;
    }

    const {projects} = item;

    if (projects && projects.length) {
      const completedProjects = _.filter(projects, (o: any) => o.status === 'completed');

      return (completedProjects.length / projects.length * 100).toFixed(0);
    }

    return 0;
  }
}
